import { bl_fi_mst_entity_vehicle_hdr_RowClass } from '../../../dbschema/bl_fi_mst_entity_vehicle_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class VehicleContainerModel extends BaseContainerModel {
bl_fi_mst_entity_vehicle_hdr: bl_fi_mst_entity_vehicle_hdr_RowClass = new bl_fi_mst_entity_vehicle_hdr_RowClass();
}
